import React from 'react'
import TabLinkUI from "../../../../widgets/output/TabLinkUI"
import './MasterTemplateNav.css'

const MasterLoanAgrLoanSpecificNavUI = ({ context, page }) =>
  <div className='g_flex_h g_flex_wrap g_flex_left g_p_left_100 master-template-nav-tertiary g_m_top_25'>
    <TabLinkUI label='NBFC Terms' to='/su/master/loanAgreement/nbfc' active={page === 'nbfc'} />
    <TabLinkUI label='PO Terms' to='/su/master/loanAgreement/po' active={page === 'po'} />
    <TabLinkUI label='PPA Terms' to='/su/master/loanAgreement/ppa' active={page === 'ppa'} />
    <TabLinkUI label='EV Terms' to='/su/master/loanAgreement/ev' active={page === 'ev'} />
  </div>

export default MasterLoanAgrLoanSpecificNavUI
